import router, {constantRouterMap} from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import {SetSideBarVisible} from "@/store/action-types";
import {SET_ROUTES, SET_SIDE_BAR_ITEMS} from "@/store/mutation-types";
import {checkSuccess, getSideBarItems} from "@/api/Apis";
import * as LogUtil from "@/utils/logUtil";
import {setSideBarsVisible} from "@/utils/sideBarUtil"; // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()

  //为空，说明还没有进行设置
  if (!store.getters.sideBarItems || store.getters.sideBarItems.length <= 0) {

    //更新一下 sideBarItems
    getSideBarItems({schoolId: store.getters.schoolId,devMode:store.getters.devMode}).then((res) => {
      if (!checkSuccess(res)) return []
      let sideBarItems = res.data.data.sideBarItems
      store.commit('permission/' + SET_SIDE_BAR_ITEMS, sideBarItems)

      LogUtil.d(" sideBarItems:", sideBarItems)
      LogUtil.d("SetSideBarVisible",constantRouterMap)
      let newRoutes = setSideBarsVisible(constantRouterMap,sideBarItems)
      store.commit('permission/'+SET_ROUTES, newRoutes)

    })

  }

  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          next()
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js